import React, { useEffect, useState, useRef } from 'react'
import { Form, Row, Col, Container } from 'react-bootstrap'
// import ftrBgThree from '../assets/images/lgnFtrBg2.png'
import waveAudio from '../assets/images/waves-audio.gif'
import waveAudiostop from '../assets/images/stopRecordingWave.jpg'
import {
    Microphone,
    CopySimple,
    ShareNetwork,
    Repeat,
    PlayCircle,
    PauseCircle,
} from 'phosphor-react'
import '../components/Login.css'
import HeaderPage from './HeaderPage'
import { voiceToText, synthesizeAudioForSegment } from './audio/speechFuncs'
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import io from 'socket.io-client'
import { Button, InputGroup, FormControl } from 'react-bootstrap'
import bharat_voice from '../assets/images/BharatAudioLive.png'
import madeinBharat from '../assets/images/madeinBharatLogo.png'
import TextToSpeech from './textToSpeech'
import * as SpeechSDK from 'microsoft-cognitiveservices-speech-sdk'
// import poster from '../assets/images/'

const languageOptions = [
    // { label: 'Assamese ', value: 'as-IN', voice: 'as-IN-PriyomNeural' }, // Removed for speech to text
    { label: 'English', value: 'en-IN', voice: 'en-IN-PrabhatNeural' },
    { label: 'Hindi', value: 'hi-IN', voice: 'hi-IN-MadhurNeural' },
    { label: 'Telugu', value: 'te-IN', voice: 'te-IN-MohanNeural' },
    { label: 'Tamil', value: 'ta-IN', voice: 'ta-IN-ValluvarNeural' },
    { label: 'Kannada', value: 'kn-IN', voice: 'kn-IN-GaganNeural' },
    // { label: 'Odia', value: 'or-IN', voice: 'or-IN-SukantNeural' }, // Removed for speech to text
    { label: 'Malayalam', value: 'ml-IN', voice: 'ml-IN-MidhunNeural' },
    { label: 'Marathi', value: 'mr-IN', voice: 'mr-IN-ManoharNeural' },
    { label: 'Gujarati', value: 'gu-IN', voice: 'gu-IN-NiranjanNeural' },
    { label: 'Bengali', value: 'bn-IN', voice: 'bn-IN-BashkarNeural' },
    { label: 'Urdu', value: 'ur-IN', voice: 'ur-IN-SalmanNeural' },
    // { label: 'Punjabi ', value: 'pa-IN', voice: 'pa-IN-OjasNeural' }, // Removed for speech to text
    // { label: "Russian", value: "ru-RU", voice: "ru-RU-DmitryNeural" },
    // { label: "Spanish", value: "es-ES", voice: "es-ES-AlvaroNeural" },
    // { label: "Chinese", value: "zh-TW", voice: "zh-TW-HsiaoChenNeural" },
    // { label: "French", value: "fr-BE", voice: "fr-BE-CharlineNeural" },
    // { label: "Arabic", value: "ar-AE", voice: "ar-AE-HamdanNeural" },
    // { label: "Portuguese", value: "pt-PT", voice: "pt-PT-FernandaNeural" },
    // { label: "Sundanese", value: "su-ID", voice: "su-ID-JajangNeural" },
    // { label: "German", value: "de-AT", voice: "de-AT-JonasNeural" },
    // { label: "Japanese", value: "ja-JP", voice: "ja-JP-AoiNeural" },
    // { label: "Korean", value: "ko-KR", voice: "ko-KR-JiMinNeural" },
    // { label: "Italian", value: "it-IT", voice: "it-IT-IsabellaNeural" },
    // { label: "Turkish", value: "tr-TR", voice: "tr-TR-EmelNeural" },
    // { label: "Malay", value: "ms-MY", voice: "ms-MY-YasminNeural" },
]
const outputLanguageOptions = [
    { label: 'Assamese ', value: 'as-IN', voice: 'as-IN-PriyomNeural' },
    { label: 'English', value: 'en-IN', voice: 'en-IN-PrabhatNeural' },
    { label: 'Hindi', value: 'hi-IN', voice: 'hi-IN-MadhurNeural' },
    { label: 'Telugu', value: 'te-IN', voice: 'te-IN-MohanNeural' },
    { label: 'Tamil', value: 'ta-IN', voice: 'ta-IN-ValluvarNeural' },
    { label: 'Kannada', value: 'kn-IN', voice: 'kn-IN-GaganNeural' },
    { label: 'Odia', value: 'or-IN', voice: 'or-IN-SukantNeural' },
    { label: 'Malayalam', value: 'ml-IN', voice: 'ml-IN-MidhunNeural' },
    { label: 'Marathi', value: 'mr-IN', voice: 'mr-IN-ManoharNeural' },
    { label: 'Gujarati', value: 'gu-IN', voice: 'gu-IN-NiranjanNeural' },
    { label: 'Bengali', value: 'bn-IN', voice: 'bn-IN-BashkarNeural' },
    { label: 'Urdu', value: 'ur-IN', voice: 'ur-IN-SalmanNeural' },
    { label: 'Punjabi ', value: 'pa-IN', voice: 'pa-IN-OjasNeural' },

    // { label: "Russian", value: "ru-RU", voice: "ru-RU-DmitryNeural" },
    // { label: "Spanish", value: "es-ES", voice: "es-ES-AlvaroNeural" },
    // { label: "Chinese", value: "zh-TW", voice: "zh-TW-HsiaoChenNeural" },
    // { label: "French", value: "fr-BE", voice: "fr-BE-CharlineNeural" },
    // { label: "Arabic", value: "ar-AE", voice: "ar-AE-HamdanNeural" },
    // { label: "Portuguese", value: "pt-PT", voice: "pt-PT-FernandaNeural" },
    // { label: "Sundanese", value: "su-ID", voice: "su-ID-JajangNeural" },
    // { label: "German", value: "de-AT", voice: "de-AT-JonasNeural" },
    // { label: "Japanese", value: "ja-JP", voice: "ja-JP-AoiNeural" },
    // { label: "Korean", value: "ko-KR", voice: "ko-KR-JiMinNeural" },
    // { label: "Italian", value: "it-IT", voice: "it-IT-IsabellaNeural" },
    // { label: "Turkish", value: "tr-TR", voice: "tr-TR-EmelNeural" },
    // { label: "Malay", value: "ms-MY", voice: "ms-MY-YasminNeural" },
]

function RealtimeVoice() {
    const SpeechSDK = window.SpeechSDK
    const navigate = useNavigate()

    const { method, sessionID } = useParams()

    const [inputTranscript, setInputTranscript] = useState([])
    const [sessionMethod, setSessionMethod] = useState(method)

    const [speakerLanguage, setSpeakerLanguage] = useState('en-IN')
    const [voice, setVoice] = useState('en-IN-PrabhatNeural')
    const [transcriptLanguage, setTranscriptLanguage] = useState('en-IN')
    const [mediaRecorder, setMediaRecorder] = useState(null)
    const [audioChunks, setAudioChunks] = useState([])
    const [wsClient, setWsClient] = useState(null)
    const [UUID, setUUID] = useState(null)
    const [speakerAvailable, setSpeakerAvailable] = useState(false)
    const [displayTranscript, setDisplayTranscript] = useState([])

    const transcriptLanguageRef = useRef(transcriptLanguage)
    const [completeTranscript, setCompleteTranscript] = useState('')
    const [copyUrl, setCopyUrl] = useState('')

    const [isDivVisible, setDivVisibility] = useState(false)
    const [Gifstatus, setGifstatus] = useState(false)

    const [startTranscriptSelected, setStartTranscriptSelected] = useState(null)

    const voiceRef = useRef(voice)

    let recordingInterval = null
    let currentStream = null

    const [recognizer, setRecognizer] = useState(null)
    const [speechBuffer, setSpeechBuffer] = useState('')
    const recognitionIntervalRef = useRef(null)

    // set last added index ref as last added index changes
    useEffect(() => {
        voiceRef.current = voice
        console.log(voiceRef.current)
    }, [voice])

    useEffect(() => {
        const onlyText = displayTranscript.map(transcript => transcript.text)
        const combinedText = onlyText.join(' ')
        console.log(combinedText)
        setCompleteTranscript(combinedText)
    }, [displayTranscript])

    useEffect(() => {
        const currentPath = window.location.pathname
        const modifiedPath = currentPath.replace('create', 'join')
        setCopyUrl(`${window.location.origin}${modifiedPath}`)
    }, [window.location.href])

    const copyToClipboard = () => {
        navigator.clipboard.writeText(copyUrl)
        alert('URL copied to clipboard')
    }

    useEffect(() => {
        transcriptLanguageRef.current = transcriptLanguage
    }, [transcriptLanguage])

    useEffect(() => {
        const correspondingOption = languageOptions.find(
            option => option.value === transcriptLanguage,
        )
        console.log(correspondingOption)
        if (correspondingOption) {
            setVoice(correspondingOption.voice)
        }
    }, [transcriptLanguage, languageOptions])

    useEffect(() => {
        const correspondingOption = languageOptions.find(
            option => option.voice === voice,
        )
        if (correspondingOption) {
            setTranscriptLanguage(correspondingOption.value)
        }
    }, [voice, languageOptions])

    async function setBatchTranslated(transcript, transcriptLanguage) {
        console.log('=== setBatchTranslated Debug ===')
        console.log('Input transcript:', transcript)
        console.log('Input transcriptLanguage:', transcriptLanguage)
        console.log(
            'transcriptLanguageRef.current:',
            transcriptLanguageRef.current,
        )

        // Check if transcript has rows property, if not, treat it as a single transcript
        let batchTranslated
        if (transcript.rows) {
            batchTranslated = transcript.rows
        } else if (Array.isArray(transcript)) {
            batchTranslated = transcript
        } else {
            // If it's a single transcript object, convert to array
            batchTranslated = [transcript]
        }

        console.log('batchTranslated:', batchTranslated)
        console.log('batchTranslated type:', typeof batchTranslated)
        console.log('batchTranslated is array:', Array.isArray(batchTranslated))

        if (!batchTranslated || batchTranslated.length === 0) {
            console.error('No batch translated data found')
            return
        }

        const key = transcriptLanguageRef.current.split('-')[0] + '_transcript'
        console.log('Using key:', key)

        // Check if the key exists in the first item
        const firstItem = batchTranslated[0]
        console.log('First item:', firstItem)
        console.log('Available keys in first item:', Object.keys(firstItem))
        console.log(`Value for key '${key}':`, firstItem[key])

        if (!firstItem[key]) {
            console.error(`Key '${key}' not found in transcript data`)
            console.log('Available keys:', Object.keys(firstItem))
            return
        }

        console.log('Starting audio synthesis for batch...')
        const batchTranslatedAudio = await Promise.all(
            batchTranslated.map(async (text, index) => {
                console.log(`Synthesizing audio for text ${index}:`, text[key])
                const audio = await synthesizeAudioForSegment(
                    text[key],
                    transcriptLanguage,
                    voiceRef.current,
                )
                console.log(`Audio result for index ${index}:`, audio)
                return audio
            }),
        )
        console.log(
            'All batch audio synthesis completed:',
            batchTranslatedAudio,
        )

        const finalTranslatedList = batchTranslated.map((text, index) => ({
            text: text[key],
            audioBuffer: batchTranslatedAudio[index],
        }))
        console.log('Final translated list:', finalTranslatedList)

        setDisplayTranscript(finalTranslatedList)
    }

    async function setFreshTranslated(transcript, transcriptLanguage) {
        console.log('=== setFreshTranslated Debug ===')
        console.log('📥 Input transcript:', transcript)
        console.log('🌐 Input transcriptLanguage:', transcriptLanguage)
        console.log(
            '🌐 transcriptLanguageRef.current:',
            transcriptLanguageRef.current,
        )

        const freshTranslatedText = transcript[transcriptLanguageRef.current]
        console.log('📝 freshTranslatedText:', freshTranslatedText)
        console.log('📝 freshTranslatedText type:', typeof freshTranslatedText)
        console.log(
            '📝 freshTranslatedText length:',
            freshTranslatedText?.length,
        )

        if (!freshTranslatedText) {
            console.error(
                '❌ No translated text found for key:',
                transcriptLanguageRef.current,
            )
            console.log(
                '🔑 Available keys in transcript:',
                Object.keys(transcript),
            )
            return
        }

        console.log('🎵 Starting audio synthesis for fresh text...')
        console.log('🎵 Calling synthesizeAudioForSegment with:')
        console.log('- text:', freshTranslatedText)
        console.log('- targetLang:', transcriptLanguage)
        console.log('- voice:', voiceRef.current)

        const freshTranslatedAudio = await synthesizeAudioForSegment(
            freshTranslatedText,
            transcriptLanguage,
            voiceRef.current,
        )
        console.log('🎵 Fresh audio synthesis result:', freshTranslatedAudio)
        console.log('🎵 Audio result type:', typeof freshTranslatedAudio)
        console.log(
            '🎵 Audio result instanceof Blob:',
            freshTranslatedAudio instanceof Blob,
        )
        console.log('🎵 Audio result size:', freshTranslatedAudio?.size)

        const newDisplayTranscript = [
            ...displayTranscript,
            {
                text: freshTranslatedText,
                audioBuffer: freshTranslatedAudio,
            },
        ]
        console.log('📝 New display transcript item:', newDisplayTranscript[0])

        setDisplayTranscript(prev => {
            const updated = [...prev, newDisplayTranscript[0]]
            console.log('📝 Updated displayTranscript:', updated)
            return updated
        })
    }

    useEffect(() => {
        setWsClient(prev => {
            if (prev) return prev
            const socket = io('https://bharataudio.vamsi-tech.org', {
                // const socket = io('https://speech.aicte-india.org', {
                reconnection: true, // whether to reconnect automatically
                reconnectionAttempts: Infinity, // number of reconnection attempts before giving up
                reconnectionDelay: 1000, // how long to initially wait before attempting a new reconnection
                reconnectionDelayMax: 50, // maximum amount of time to wait between reconnection attempts
            })

            console.log('🔌 Socket instance created:', socket)
            console.log('🔌 Socket ID:', socket.id)
            console.log('🔌 Socket connected:', socket.connected)

            socket.on('connect', () => {
                console.log('✅ Socket connected successfully!')
                console.log('🔌 Connected Socket ID:', socket.id)
                console.log('🔌 Session Method:', sessionMethod)
                console.log('🔌 Session ID:', sessionID)

                if (sessionMethod === 'create') {
                    console.log('📤 Emitting create_session with:', {
                        sessionID,
                    })
                    socket.emit('create_session', { sessionID })
                }
                if (sessionMethod === 'join') {
                    console.log('📤 Emitting join_session with:', { sessionID })
                    socket.emit('join_session', { sessionID })
                }
            })

            socket.on('disconnect', reason => {
                console.log('❌ Socket disconnected:', reason)
                console.log('🔌 Disconnected Socket ID:', socket.id)
            })

            socket.on('connect_error', error => {
                console.error('🚨 Socket connection error:', error)
            })

            socket.on('reconnect', attemptNumber => {
                console.log(
                    '🔄 Socket reconnected after',
                    attemptNumber,
                    'attempts',
                )
            })

            socket.on('reconnect_error', error => {
                console.error('🚨 Socket reconnection error:', error)
            })

            socket.on('init', data => {
                console.log('📥 Received init event:', data)
                console.log('🎤 Speaker available:', data.speaker_available)
                setSpeakerAvailable(data.speaker_available)
            })

            socket.on('session_error', data => {
                console.error('🚨 Session error received:', data)
                console.log('❌ Error message:', data.error)
                alert(data.error)
                navigate('/realtimeVoice')
            })

            socket.on('session_created', () => {
                console.log('✅ Session created successfully')
                // setSessionMethod("join");
            })

            socket.on('transcript', data => {
                console.log('📥 Received transcript event:', data)
                console.log('📝 Raw transcript data:', data.transcript)
                console.log(
                    '🌐 Current transcript language:',
                    transcriptLanguageRef.current,
                )
                setFreshTranslated(
                    data.transcript,
                    transcriptLanguageRef.current,
                )
            })

            socket.on('start_transcript', data => {
                console.log('📥 Received start_transcript event:', data)
                console.log('📝 Batch transcript data:', data.transcript)
                console.log(
                    '🌐 Current transcript language:',
                    transcriptLanguageRef.current,
                )
                setBatchTranslated(
                    data.transcript,
                    transcriptLanguageRef.current,
                )
            })

            socket.on('clear_transcript', () => {
                console.log(
                    '🗑️ Received clear_transcript event - clearing display transcript',
                )
                setDisplayTranscript([])
            })

            return socket
        })
        return () => {
            if (wsClient) {
                console.log('🔌 Disconnecting socket on cleanup')
                wsClient.disconnect()
            }
        }
    }, [])

    const startRecording = () => {
        setGifstatus(true)
        // Replace with your Azure Speech key and region
        const speechKey = 'a0108c17e18a45d0b8c7b1e38fd984cd'
        const serviceRegion = 'centralindia' // e.g., 'eastus'

        const speechConfig = SpeechSDK.SpeechConfig.fromSubscription(
            speechKey,
            serviceRegion,
        )
        speechConfig.speechRecognitionLanguage = speakerLanguage // e.g., 'en-IN'

        const audioConfig = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput()
        const reco = new SpeechSDK.SpeechRecognizer(speechConfig, audioConfig)

        setRecognizer(reco)
        setSpeechBuffer('')

        reco.recognized = (s, e) => {
            if (
                e.result.reason === SpeechSDK.ResultReason.RecognizedSpeech &&
                e.result.text
            ) {
                setSpeechBuffer(prev => {
                    const newBuffer = (prev + ' ' + e.result.text).trim()
                    // Split on sentence-ending punctuation
                    const sentences = newBuffer.match(/[^.!?]+[.!?]+/g) || []
                    let remainder = newBuffer
                    sentences.forEach(sentence => {
                        transcribeText(sentence.trim())
                        // Remove this sentence from the remainder
                        remainder = remainder.replace(sentence, '')
                    })
                    return remainder.trim()
                })
            }
        }

        reco.startContinuousRecognitionAsync()

        // Every 10 seconds, send any remaining buffer (even if not a full sentence)
        recognitionIntervalRef.current = setInterval(() => {
            setSpeechBuffer(prev => {
                if (prev.length > 0) {
                    transcribeText(prev.trim())
                    return ''
                }
                return prev
            })
        }, 10000)
    }

    const stopRecording = () => {
        setGifstatus(false)
        if (recognizer) {
            recognizer.stopContinuousRecognitionAsync(() => {
                setRecognizer(null)
            })
        }
        if (recognitionIntervalRef.current) {
            clearInterval(recognitionIntervalRef.current)
            recognitionIntervalRef.current = null
        }
        // Send any remaining buffer
        setSpeechBuffer(prev => {
            if (prev.length > 0) {
                transcribeText(prev.trim())
                return ''
            }
            return prev
        })
    }

    // Helper to send recognized text
    const transcribeText = text => {
        if (!wsClient) {
            console.warn('No wsClient, cannot send transcript')
            return
        }
        if (!sessionID) {
            console.warn('No sessionID, cannot send transcript')
            return
        }
        wsClient.emit('transcript_add', {
            sessionID,
            transcript: text,
            transcript_language: speakerLanguage,
            uuid: UUID,
        })
        // Optionally, update the UI
        setInputTranscript(prev => {
            if (prev[prev.length - 1] === text) {
                return prev // Don't add duplicate
            }
            return [...prev, text]
        })
    }

    const setInputLanguage = e => {
        setSpeakerLanguage(e.target.value)
    }

    const handleTranscriptLanguageChange = e => {
        setTranscriptLanguage(e.target.value)
    }

    const startTranscript = () => {
        console.log('▶️ Starting transcript...')
        console.log('🌐 Transcript language:', transcriptLanguage)
        console.log('🆔 UUID:', UUID)

        const emitData = {
            sessionID,
            language: transcriptLanguage,
            uuid: UUID,
        }
        console.log('📤 Emitting start_transcript with:', emitData)

        wsClient.emit('start_transcript', emitData)
        setStartTranscriptSelected(true)
        console.log('✅ startTranscriptSelected set to true')
    }

    const endSession = () => {
        // stop audio recording
        if (mediaRecorder) {
            mediaRecorder.stop()
        }
        window.location.href = '/realtimeVoice'
    }
    const recordingComponent = (
        <div className="formWidth realtimeVoiceDiv">
            <Form>
                <Row className="align-items-end">
                    <Col className="col-6 slctLangSec slctLangSecDiv">
                        <Form.Group>
                            <Form.Label>Select Language</Form.Label>
                            <Form.Select
                                className="form-control"
                                onChange={setInputLanguage}
                            >
                                {languageOptions.map(option => (
                                    <option
                                        key={option.value}
                                        value={option.value}
                                    >
                                        {option.label}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col className="col-6 playPausebtnDiv">
                        <Form.Group className="d-flex justify-content-start btnGroup">
                            {!Gifstatus ? (
                                <button
                                    className={
                                        Gifstatus
                                            ? 'btn btn-success microphoneBtn microActive'
                                            : 'btn btn-success microphoneBtn'
                                    }
                                    type="button"
                                    title="Start Recording"
                                    onClick={startRecording}
                                >
                                    <Microphone size={32} />
                                </button>
                            ) : (
                                <button
                                    className="btn btn-danger stopRecBtn"
                                    type="button"
                                    title="Stop Recording"
                                    onClick={stopRecording}
                                >
                                    <PauseCircle size={32} />
                                </button>
                            )}

                            <button
                                className={`btn btn-info me-2 repeatBtn`}
                                onClick={endSession}
                                type="button"
                            >
                                End Session
                            </button>

                            {/* {isDivVisible && (
                                <span className="audioWave">
                                    <img
                                        src={
                                            Gifstatus
                                                ? waveAudiostop
                                                : waveAudio
                                        }
                                        alt=""
                                    />
                                </span>
                            )} */}
                            {/* {Gifstatus ? 'recording' : 'not recording'} */}
                        </Form.Group>
                    </Col>
                </Row>
            </Form>
            {/* Display speech-to-text results */}
            {inputTranscript.length > 0 && (
                <div className="mt-3">
                    <h5>Speech to Text Results:</h5>
                    <ul>
                        {inputTranscript.map((text, idx) => (
                            <li key={idx}>{text}</li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    )

    const combinedComponent = (
        <div className="formWidth">
            <div className="formGroupDiv w-100">
                <Form.Group
                    // style={{
                    //   display: "flex",
                    //   justifyContent: "space-between",
                    //   alignItems: "end",
                    //   flexFlow: "wrap",
                    // }}
                    className="row"
                >
                    <div className="col-md-4">
                        <Form.Label>Select Language</Form.Label>
                        <Form.Select
                            value={transcriptLanguage}
                            onChange={handleTranscriptLanguageChange}
                            className="form-control" // Adjust width as needed
                            style={{ height: '50px' }}
                        >
                            {outputLanguageOptions.map(option => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </Form.Select>
                    </div>
                    <div
                        className="playRepeatBtn d-flex justify-content-start"
                        style={{ marginTop: '1rem' }}
                    >
                        {/* <button
              className={`btn btn-info me-2 playBtnN`}
              onClick={playFromLive}
              type="button"
            >
              <PlayCircle size={32} />
            </button>
            <button
              className={`btn btn-info me-2 repeatBtn`}
              onClick={playFromStart}
              type="button"
            >
              <Repeat size={32} />
            </button> */}

                        {startTranscriptSelected && (
                            <>
                                {console.log(
                                    '=== TextToSpeech Component Rendering ===',
                                )}
                                {console.log(
                                    'displayTranscript:',
                                    displayTranscript,
                                )}
                                {console.log(
                                    'audioBuffers being passed:',
                                    displayTranscript.map(
                                        transcript => transcript.audioBuffer,
                                    ),
                                )}
                                {console.log(
                                    'transcripts being passed:',
                                    displayTranscript.map(
                                        transcript => transcript.text,
                                    ),
                                )}
                                {console.log(
                                    'startTranscriptSelected being passed:',
                                    startTranscriptSelected,
                                )}
                                <TextToSpeech
                                    audioBuffers={displayTranscript.map(
                                        transcript => transcript.audioBuffer,
                                    )}
                                    transcripts={displayTranscript.map(
                                        transcript => transcript.text,
                                    )}
                                    startTranscriptSelected={
                                        startTranscriptSelected
                                    }
                                />
                            </>
                        )}
                        {startTranscriptSelected === null && (
                            <button
                                className="btn btn-info mt-2 startTrans"
                                onClick={startTranscript}
                            >
                                Select language and Submit
                            </button>
                        )}
                    </div>

                    <div className="startTransDiv"></div>
                </Form.Group>
            </div>
            <div className="col">
                {/* <b>Transcript</b>
          <br /> */}
                <br></br>
                <br></br>
                <br></br>
                <div
                    style={{
                        maxHeight: '300px',
                        overflow: 'scroll',
                        width: '100vw !important',
                    }}
                >
                    {completeTranscript}
                </div>
                <button
                    className={`btn btn-info me-2 repeatBtn`}
                    onClick={endSession}
                    type="button"
                >
                    End Session
                </button>
            </div>
        </div>
    )
    function shareUrl() {
        if (navigator.share) {
            navigator
                .share({
                    title: 'Share URL',
                    url: copyUrl, // Your URL to share
                })
                .then(() => {
                    console.log('Thanks for sharing!')
                })
                .catch(console.error)
        } else {
            // fallback for devices where the Web Share API is not supported
            console.log('Web Share not supported on this device')
        }
    }

    return (
        <>
            <HeaderPage />
            {/*        <img
                src={poster}
                alt="poster"
                style={{
                    width: '100%',
                }}
            />
             */}
            <br></br>
            <section className="copyUrlSec newcopySec">
                <div className="sessionDiv">
                    <Container>
                        <div
                            className="sesnLogoDiv cntnrLogo"
                            style={{
                                display: 'flex',
                                alignContent: 'flex-start',
                                justifyContent: 'center',
                            }}
                        >
                            <img
                                src={bharat_voice}
                                style={{ height: '14vh' }}
                                alt="logo"
                            />{' '}
                            <img
                                className="madeInBhrt"
                                src={madeinBharat}
                                style={{ height: '10vh' }}
                                alt="logo"
                            />
                        </div>
                        <div className="videoSldrCnt videoVoicecoourl">
                            <h2>Bharat Audio Live: Voice Uniting Bharat</h2>
                            <p>
                                Bharat Audio Live is a digital marvel, a
                                platform where languages don't divide but unite,
                                where voices traverse the expanse of this vast
                                country, seamlessly weaving through its many
                                tongues.{' '}
                            </p>
                            <p>
                                Imagine a fisherman in the serene backwaters of
                                Andhra pradesh. His native Telugu rolls off his
                                tongue, rich and melodious. But today, he speaks
                                not just to his usual comrades but to an
                                audience in Punjab. As his voice travels through
                                Bharat Audio Live, it transforms, emerging in
                                fluent Punjabi. A farmer in the golden wheat
                                fields of Punjab listens intently, his
                                smartphone a window to this shared experience,
                                transcending miles and languages.
                            </p>
                            <p>
                                In the bustling streets of Kolkata, a Bengali
                                poet recites her latest work. Her words, steeped
                                in emotion, flow through Bharat Audio Live,
                                reaching a young Rajasthani artist in the
                                deserts of Jaisalmer. As the poetry finds its
                                voice in Rajasthani, the artist's brush strokes
                                begin to dance, inspired by words that were once
                                foreign, now familiar and understood.
                            </p>
                            <p>
                                Bharat Audio Live isn't just a technological
                                marvel; it's a cultural tapestry. It brings
                                together the Tamil entrepreneur, sharing
                                business insights with budding Gujarati
                                businessmen; the Marathi professor, whose
                                lectures on history captivate students in
                                Telugu-speaking Andhra Pradesh; the Kashmiri
                                storyteller, whose tales enthrall listeners in
                                the far south.
                            </p>
                            <p>
                                The platform's transcript feature adds another
                                layer of connection. Not just heard, these
                                conversations are also seen, words flowing
                                across screens in multiple languages, ensuring
                                that every nuance, every emotion, is captured
                                and understood. It's a tool for the deaf, an aid
                                for the learner, a gift for the curious.
                            </p>
                            <p>
                                As night falls over the Indian subcontinent,
                                Bharat Audio Live continues its dance of
                                languages. It's more than an app; it's a
                                celebration of diversity, a testament to unity
                                in variety. In a land of over a billion voices,
                                each one finds a place, a listener, a friend in
                                Bharat Audio Live. It's where every voice
                                matters, every story is heard, and every word
                                builds bridges.
                            </p>
                            <p>
                                "Bharat Audio Live" is creatively presented,
                                capturing the essence of diversity and
                                connectivity in India.
                            </p>
                        </div>
                        <InputGroup className="mb-3 copyShreBtn">
                            <FormControl readOnly value={copyUrl} />
                            <Button
                                variant="outline-secondary copyBtnBtn"
                                onClick={copyToClipboard}
                            >
                                <CopySimple size={32} />
                            </Button>
                            <Button
                                variant="outline-secondary sharebtnUrl"
                                onClick={shareUrl}
                            >
                                <ShareNetwork size={32} />
                            </Button>
                        </InputGroup>

                        {/* <span className="btmTpThreeImg"> */}
                        {/* <img src={ftrBgThree} alt="" /> */}
                        {/* </span> */}
                        {method === 'create' && recordingComponent}
                        {method === 'join' && combinedComponent}
                        {/* {method === "join" && transcriptComponent } */}
                        {/* {method === "join" && audioPlayComponent}  */}
                    </Container>
                </div>
            </section>
        </>
    )
}

export default RealtimeVoice
